// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_le-0";